import { Cargo } from '../interfaces/cargo';
import { TransportCompanyChangeJobStatus } from '../interfaces/transport-company-change';

export const DOCUMENT_RECREATION_IN_PROGRESS_MESSAGE =
  'Hay un proceso de recreación de remesas y manifiesto en curso. Podrás realizar cambios cuando finalice.';

export const DOCUMENT_RECREATION_IN_PROGRESS_TITLE =
  'Recreación de manifiesto y remesas en proceso';

export function isDocumentRecreationInProgress(cargo: Cargo): boolean {
  return !!(cargo && cargo.activeTransportCompanyChangeJobId);
}

export function getTransportCompanyChangeStepLabel(
  currentStep: string,
  status?: TransportCompanyChangeJobStatus
): string {
  const normalizedStep = currentStep
    ? currentStep
      .trim()
      .replace(/([a-záéíóúñ])([A-ZÁÉÍÓÚÑ])/g, '$1-$2')
      .replace(/[_\s]+/g, '-')
      .toLowerCase()
    : '';
  const labels: { [step: string]: string } = {
    validate: 'Validando la información del cambio',
    validating: 'Validando la información del cambio',
    validation: 'Validando la información del cambio',
    cancel: 'Anulando documentos RNDC',
    cancelling: 'Anulando documentos RNDC',
    cancellation: 'Anulando documentos RNDC',
    'cancel-documents': 'Anulando documentos RNDC',
    'cancel-rndc-documents': 'Anulando documentos RNDC',
    'cancel-cumplido': 'Anulando cumplido',
    'cancel-fulfillment': 'Anulando cumplido',
    'cancel-manifiesto': 'Anulando manifiesto',
    'cancel-manifest': 'Anulando manifiesto',
    'cancel-remesa': 'Anulando remesa',
    'cancel-consignment': 'Anulando remesa',
    switch: 'Actualizando contratante y empresa de transporte',
    switching: 'Actualizando contratante y empresa de transporte',
    'switch-transport-company': 'Actualizando empresa de transporte',
    'switch-contractor': 'Actualizando contratante',
    recreate: 'Recreando documentos RNDC',
    recreating: 'Recreando documentos RNDC',
    'recreate-documents': 'Recreando documentos RNDC',
    'recreate-rndc-documents': 'Recreando documentos RNDC',
    'recreate-remesa': 'Recreando remesa',
    'recreate-consignment': 'Recreando remesa',
    'recreate-manifiesto': 'Recreando manifiesto',
    'recreate-manifest': 'Recreando manifiesto',
    'recreate-cumplido': 'Recreando cumplido',
    'recreate-fulfillment': 'Recreando cumplido',
    done: 'Proceso finalizado',
    completed: 'Proceso finalizado',
    failed: 'Proceso detenido'
  };
  if (labels[normalizedStep]) return labels[normalizedStep];

  const statusLabels: { [jobStatus: string]: string } = {
    PENDING: 'Preparando el cambio solicitado',
    VALIDATING: 'Validando la información del cambio',
    CANCELLING: 'Anulando documentos RNDC',
    SWITCHING: 'Actualizando contratante y empresa de transporte',
    RECREATING: 'Recreando documentos RNDC',
    DONE: 'Proceso finalizado',
    FAILED: 'Proceso detenido'
  };
  return statusLabels[status] || 'Procesando el cambio solicitado';
}

export function isContractorTransportEditionBlockedByBilling(cargo: Cargo): boolean {
  const shippingCost = cargo && cargo.shippingCost;
  const billId = shippingCost && shippingCost.billId;
  const preBill = cargo && cargo.preBill;
  return !!(shippingCost && (shippingCost.cashed === true || !!preBill || !!billId));
}

export function shouldQueryTransportCompanyChangeJob(cargo: Cargo, isContractorTransportDialog: boolean): boolean {
  return isContractorTransportDialog && isDocumentRecreationInProgress(cargo);
}
